import { TFunction } from 'i18next'
import React from 'react'
import { CommonPriceElementGroup } from 'common/components/entities/price-element/price-element-group'
import {
  PriceElementGroupInterface,
  PriceElementPeriodInterface,
} from 'common/components/entities/price-element/price-element-interface'
import { CommonPriceElementPeriod } from 'common/components/entities/price-element/price-element-period'
import { CommonPriceElementPlans } from 'common/components/entities/price-element/price-element-plans'
import {
  CommonPriceElementWrapperUi,
  CommonPriceElementContainerUi,
  CommonPriceElementTableContainerUi,
  CommonPriceElementTitleUi,
  CommonPriceElementPlansWrapperUi,
} from 'common/components/entities/price-element/ui'
import {
  getDefaultPricePeriod,
  getPriceGroupDefault,
} from 'common/components/entities/price-element/utils'
import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'

interface PriceElementSkeletonProps {
  locale: PageLocaleEnum
  t: TFunction
}

export const PriceElementSkeleton = ({
  locale = PageLocaleEnum.ENGLISH,
  t,
}: PriceElementSkeletonProps) => {
  const pricePeriod: PriceElementPeriodInterface[] = getDefaultPricePeriod(
    4,
    'monthly',
  )
  const priceGroup: PriceElementGroupInterface[] = getPriceGroupDefault()

  return (
    <CommonPriceElementWrapperUi>
      <CommonPriceElementContainerUi>
        <CommonPriceElementTitleUi>
          {t('components.price_element.title')}:
        </CommonPriceElementTitleUi>
        <CommonPriceElementPlansWrapperUi>
          <CommonPriceElementPeriod
            locale={locale}
            activeBtn={'monthly'}
            onClick={() => {}}
            t={t}
            isLoading
          />
          <CommonPriceElementPlans
            locale={locale}
            plans={pricePeriod}
            onClick={() => {}}
            activeIndex={0}
            syncScroll={() => {}}
            registerContainer={() => {}}
            t={t}
            isLoading
          />
        </CommonPriceElementPlansWrapperUi>
        <CommonPriceElementTableContainerUi>
          {priceGroup.map(el => (
            <CommonPriceElementGroup
              key={el.id}
              locale={locale}
              data={el}
              syncScroll={() => {}}
              registerContainer={() => {}}
              t={t}
              isLoading
            />
          ))}
        </CommonPriceElementTableContainerUi>
      </CommonPriceElementContainerUi>
    </CommonPriceElementWrapperUi>
  )
}
